export const googleAuthButtonI18NPl = {
    withGoogle: "z Google",
};
